import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-xl-8 col-md-10 col-12 text-center" }
const _hoisted_3 = {
  key: 0,
  class: "row d-flex justify-content-center"
}
const _hoisted_4 = { class: "col-1 mt-3 mb-3" }
const _hoisted_5 = { class: "progress-spinner progress-spinner-double size-sm progress-spinner-active" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_8 = { class: "visually-hidden" }
const _hoisted_9 = {
  key: 1,
  class: "row justify-content-center"
}
const _hoisted_10 = {
  key: 0,
  class: "col-12"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = {
  key: 2,
  class: "row d-flex justify-content-center mt-4"
}
const _hoisted_15 = { class: "col-12 col-md-6 col-lg-4 d-grid gap-2" }

import { onMounted, ref, inject, onUnmounted, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "../../models/Store/store";
import { useTenantConfig } from "../../composables/useTenantConfig";
import api from "@/services/BookingService";
import _ from "lodash";

import moment from "moment";
import { AxiosError } from "axios";
import { DateAvailableModel } from "@/models/Calendar/DateAvailableModel";
import { MonthAvailable } from "@/models/Step/MonthAvailableModel";
import { DayAvailable } from "@/models/Step/DayAvailableModel";
import { useI18n } from "vue-i18n";
import constants from "@/models/Utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookDate',
  setup(__props) {

const { getWebDelayDaysForLocation } = useTenantConfig();
const router = useRouter();
const store = useStore();
const { t } = useI18n();
const emitter = inject("emitter");

const selectedItem = ref(null);
const loadingDates = ref(false);
const datesAvailable = ref([]);

onMounted(() => {
  store.stepsMade.month = null;
  store.stepsMade.day = null;

  const localeCode = t("settings.localeCode");
  moment.locale(localeCode);

  emitter.on(constants.GO_NEXT_STEP, () => {
    console.log("received goNextStep BookDate");
    goToNextStep();
  });

  if (
    _.isNull(store.stepsMade) === false &&
    _.isNull(store.stepsMade.service) === false &&
    _.isNull(store.stepsMade.location) === false
  ) {
    getData();
  }
});

watch(
  () => selectedItem.value,
  (newVal) => {
    if (newVal) {
      //emitter.emit(constants.CAN_GO_NEXT_STEP, true);
      goToNextStep();
    } else {
      emitter.emit(constants.CAN_GO_NEXT_STEP, false);
    }
  },
  { immediate: true }
);

const getData = () => {
  loadingDates.value = true;
  const delayDays = getWebDelayDaysForLocation(store.stepsMade.location.id);

  let friendlyCodeEditing = null;
  if (store.bookedit) {
    friendlyCodeEditing = store.bookedit.friendlyCode;
  }

  api
    .getNextDaysAvailability(
      store.tenantSelected.id,
      store.stepsMade.service.id,
      store.stepsMade.location.id,
      delayDays,
      "web",
      friendlyCodeEditing
    )
    .then((response) => {
      if (_.isNull(response) === false && _.isUndefined(response) === false) {
        if (
          _.isNull(response.data) === false &&
          _.isUndefined(response.data) === false
        ) {
          if (
            _.isNull(response.data.availabilities) === false &&
            _.isUndefined(response.data.availabilities) === false
          ) {
            if (
              _.isArray(response.data.availabilities) &&
              response.data.availabilities.length > 0
            ) {
              for (let i = 0; i < response.data.availabilities.length; i++) {
                let interval = response.data.availabilities[i];
                interval.dayName = _.upperFirst(interval.dayName);
                interval.monthName = _.upperFirst(interval.monthName);
                datesAvailable.value.push(interval);
              }
            }
          }
        }
      }

      loadingDates.value = false;
    })
    .catch((err: AxiosError) => {
      console.log("Errore nella get delle prossime x disponibilità");
      loadingDates.value = false;
    });
};

const selectedDate = (item: DateAvailableModel) => {
  if (_.isNull(item) === false && _.isUndefined(item) === false) {
    const monthStep = new MonthAvailable();
    monthStep.id = item.id;
    monthStep.month = item.month;
    monthStep.monthName = item.monthName;
    monthStep.year = item.year;
    monthStep.name = item.monthName + " " + item.year;
    store.stepsMade.month = monthStep;

    const dayStep = new DayAvailable();
    dayStep.id = item.id;
    dayStep.day = item.day;
    dayStep.dayName = item.dayName;
    selectedItem.value = dayStep;
  }
};

const goToNextStep = () => {
  store.stepsMade.day = selectedItem.value;
  router.push({ name: "bookorari" });
};

const isItemSelected = (item: DateAvailableModel) => {
  if (_.isNull(selectedItem.value) === false) {
    if (
      selectedItem.value.month === item.month &&
      selectedItem.value.day === item.day &&
      selectedItem.value.year === item.year
    ) {
      return true;
    }
  }
  return false;
};

const bookEditHasSameDate = (item: DateAvailableModel) => {
  if (_.isNull(store.bookedit) === false) {
    const date = moment(store.bookedit.fromDate);
    const monthFromPreviousValue = date.month() + 1;
    const dayFromPreviousValue = date.date();

    if (
      monthFromPreviousValue === item.month &&
      dayFromPreviousValue === item.day
    ) {
      return true;
    }
  }
  return false;
};

const goToBookMonth = () => {
  router.push({ name: "bookmonth" });
};

onUnmounted(() => emitter.off(constants.GO_NEXT_STEP));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, [
          _createElementVNode("b", null, _toDisplayString(_unref(t)("titles.selectBookingDate")), 1)
        ])
      ])
    ]),
    (loadingDates.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)("common.loadingText")), 1)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (datesAvailable.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("label", null, [
                  _createElementVNode("b", null, _toDisplayString(_unref(t)("messages.noAvailability")), 1)
                ])
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(datesAvailable.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 d-grid gap-2",
                  key: item.id
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["btn btn-lg my-3", [
            isItemSelected(item) ? 'btn-primary' : 'btn-outline-primary',
          ]]),
                    onClick: ($event: any) => (selectedDate(item))
                  }, [
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(item.dayName) + " ", 1),
                      _hoisted_12,
                      _createTextVNode(" " + _toDisplayString(item.day) + " ", 1),
                      _hoisted_13,
                      _createTextVNode(" " + _toDisplayString(item.monthName), 1)
                    ])
                  ], 10, _hoisted_11)
                ]))
              }), 128))
        ])),
    (!loadingDates.value && datesAvailable.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-primary btn-sm my-3",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (goToBookMonth()))
            }, [
              _createElementVNode("div", null, _toDisplayString(_unref(t)("common.otherDate")), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})